import React from 'react'
import { userControlModel } from '../userControlModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '../../organization/orgModel'

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = userControlModel()
    const { getOrgTreeSelect } = useOrgModel(() => [])

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '用户编码',
            fieldName: 'code',
            span:4
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '用户名称',
            fieldName: 'name',
            span:4
        },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "所属部门",
            fieldName: "orgCode",
            span:3,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: '用户类型',
        //     fieldName: 'vehicleBrandCode',
        //     options: getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND),
        //     span:4
        // },
        {
            type: SearchTypeEnum.Input,
            placeholder: '联系电话',
            fieldName: 'phoneNumber',
            span:4
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: '用户状态',
        //     fieldName: 'status',
        //     options: [{label:'开启',value:0},{label:'关闭',value:1}],
        //     span:4
        // }
    ]
    const searchMoreFields= [


    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
